jQuery($ => {

    function openNavDropdown(el) {
        const $parentItem = $(el).closest(".m-page-nav__item--parent");
        const $list = $parentItem.find(".m-page-nav__sub-list");
        const $link = $list.find(".m-page-nav__sub-item:first-child .a-nav-link");

        $parentItem.addClass("open");
        $parentItem.css('z-index', '10');
        $list.show();
        $link.focus();
    }

    function closeNavDropdown(el) {
        const $parentItem = $(el).closest(".m-page-nav__item--parent");
        const $list = $parentItem.find('.m-page-nav__sub-list');
        const $button = $parentItem.find(".m-page-nav__item--parent .a-nav-link:first-child");

        $parentItem.removeClass("open");
        $parentItem.css('z-index', '2');
        $list.hide();

        if (!$(el).is('.m-page-nav__sub-list .a-nav-link[href^="#"]')) {
            $button.focus();
        }
    }

    function toggleNavDropdown(el) {
        const $parentItem = $(el).closest(".m-page-nav__item--parent");

        if ($parentItem.hasClass('open')) {
            closeNavDropdown(el);
        } else {
            openNavDropdown(el);
        }
    }

    function searchDropdownList(el, query) {
        const $parentItem = $(el).closest(".m-page-nav__item--parent");
        const $links = $parentItem.find(".m-page-nav__sub-list .a-nav-link");
        const queryText = query.trim().toLowerCase();

        $links
            .filter(function () {
                const linkText = $(this)
                    .text()
                    .trim()
                    .toLowerCase();
                return linkText.indexOf(queryText) === 0;
            })
            .first()
            .focus();
    }

    $(window).on('load ajax', function () {
        if ($(".m-page-nav__item--parent")[0]) {
            $(".m-page-nav__item--parent .a-nav-link:first-child").keydown(function (e) {
                switch (e.key) {
                    case "Enter":
                    case "spacebar":
                    case " ":
                    case "ArrowDown":
                    case "ArrowUp":
                        e.preventDefault();
                        openNavDropdown(this);
                        break;
                }
            });

            $(".m-page-nav__item--parent .a-nav-link:first-child .a-nav-link").blur(function (e) {
                const newTarget = e.relatedTarget;

                if (
                    newTarget === null ||
                    e.target.offsetParent !== newTarget.offsetParent
                ) {
                    closeNavDropdown(e.target);
                }
            });

            let dropdownSearchTimeout = false;
            let dropdownSearchQuery = "";

            $(".m-page-nav__sub-list .a-nav-link").keydown(function (e) {
                switch (e.key) {
                    case "Escape":
                    case "Esc":
                    case "Delete":
                    case "Backspace":
                        e.preventDefault();

                        closeNavDropdown(this);
                        break;

                    case "ArrowUp":
                        e.preventDefault();

                        var prevItem = e.target.parentNode.previousElementSibling;
                        if (prevItem) $(prevItem).find('.a-nav-link').focus();
                        break;

                    case "ArrowDown":
                        e.preventDefault();

                        var nextItem = e.target.parentNode.nextElementSibling;
                        if (nextItem) $(nextItem).find('.a-nav-link').focus();
                        break;

                    case "Tab":
                        if (
                            ($(this).parent().is(':first-child') && e.shiftKey) ||
                            ($(this).parent().is(':last-child') && !e.shiftKey)
                        ) {
                            e.preventDefault();
                        }
                        break;

                    case "Enter":
                        break;

                    default:
                        e.preventDefault();

                        dropdownSearchQuery += e.key;

                        searchDropdownList(this, dropdownSearchQuery);

                        if (dropdownSearchTimeout) clearTimeout(dropdownSearchTimeout);

                        dropdownSearchTimeout = setTimeout(function () {
                            dropdownSearchQuery = "";
                        }, 1000);
                }
            });
        }
    });
});